<template>
  <s-task-list-layout
    :title="$t(workItem.nameI18nCode)"
    :signbasket="isShowSignBasket"
    :history-u-r-l="`/tasklist/generalGroupListHistory/${businessCode}/${currGroupId?currGroupId:''}`"
  >
    <template v-slot:toolbarExtension>
      <s-group-selector
        ref="groupSelector"
        :key="sGroupSelectorKey"
        :business-code="businessCode"
        :curr-group-id.sync="currGroupId"
      />
    </template>

    <v-skeleton-loader
      v-if="loading"
      type="list-item-avatar-two-line, divider, list-item-avatar-two-line"
    />

    <div v-if="!loading">
      <s-class-pdf-muti
        v-model="dialog"
        :file-ctxs="files"
      />
      <template v-for="(task) in taskList">
        <v-sheet
          :key="task.id"
          color="white"
          class="mb-4"
        >
          <div class="pa-3">
            <h3>
              {{ $chPtObjData('chinTaskListTitle', task.formAttribute) }}
            </h3>

            <div
              v-if="!isApp && task.businessCode !== BUSINESS_CODE.TRAINING && task.businessCode !== BUSINESS_CODE.LEAVE_MARK"
              style="float: right;"
            >
              <s-view-doc-btn @previewFile="previewGeneralFileList(task)" />
              <!-- <s-class-pdf
                :url="task.pdfInitParams"
              /> -->
            </div>

            {{ $chPtObjData('chinContent', task) }}<br>
            <div class="grey--text">
              {{ $chPtObjData('chinTaskListDesc1', task.formAttribute) }}
            </div>
            <div class="grey--text">
              {{ $chPtObjData('chinTaskListDesc2', task.formAttribute) }}
            </div>
            <div
              v-if="task.businessCode == BUSINESS_CODE.TRAINING"
              class="grey--text"
            >
              {{ $t('TaskList.Applicant') }} {{ $chPtObjData('applicantChinName', task) }}
            </div>

            <br v-if="task.formMessage && task.formMessage.message">

            <div
              v-if="task.formMessage && task.formMessage.message"
              class="pa-3 grey lighten-4"
            >
              {{ $chPtObjData('chinMessageFrom',task.formMessage) }}: {{ task.formMessage.message }}
            </div>

            <div v-if="task.workItemHistoryList && task.workItemHistoryList.length">
              <br>
              <s-flow-detail-dialog :work-item-history="task.workItemHistoryList" />
            </div>
            <br v-if="task.formMessage && task.formMessage.privateMessage">
            <div
              v-if="task.formMessage && task.formMessage.privateMessage"
              class="pa-3 grey lighten-4"
            >
              {{ $chPtObjData('chinPrivateMessageFrom',task.formMessage) }} <v-icon>{{ mdiRedo }}</v-icon>: {{ task.formMessage.privateMessage }}
            </div>
          </div>

          <v-divider light />

          <!-- 轉交-->
          <div class="text-right pa-2">
            <s-transfer-task
              :task="task"
              :require-message="requireMessage"
              @transfer-task="transferTaskToStaff(task, $event)"
            />

            <v-tooltip
              v-if="task.businessCode !== BUSINESS_CODE.TRAINING"
              color="black"
              top
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  :disabled="isApprove(task.isAddedToSigningCart)"
                  class="mr-2"
                  color="error"
                  :loading="cancelLoading[task.id]"
                  v-on="on"
                  @click="askWhetherCancelTask(task)"
                >
                  <v-icon>
                    {{ mdiClose }}
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ $t('Text.Cancel') }}</span>
            </v-tooltip>
          </div>
        </v-sheet>
      </template>

      <s-delete-dialog
        v-if="currentTask"
        v-model="isShowCancelTaskDialog"
        :has-unapprove="false"
        @delete="confirmDelete($event)"
      />

      <template v-if="taskList.length === 0">
        <v-sheet>
          <div class="px-4 py-3">
            {{ $t('PublicServant.NoData') }}
          </div>
        </v-sheet>
      </template>
      <div>
        <v-pagination
          v-if="totalPage"
          v-model="page"
          :length="totalPage"
          circle
          @input="handlePageChange"
        />
      </div>
    </div>
  </s-task-list-layout>
</template>

<script>
import { mdiRedo, mdiClose } from '@mdi/js'
import { mapState } from 'vuex'
import STaskListLayout from './components/STaskListLayout'
import STransferTask from './components/STransferTask'
import { workflow } from '../../store/modules/workflow/workflow'
import store from '../../store'
import { workflowModule } from '../../store/moduleName'
import { taskMethod } from '../../mixins/taskMethod'
// import SClassPdf from '../../components/SClassPdf'
import SClassPdfMuti from '@/components/SClassPdfMuti'
import SViewDocBtn from './components/GeneralList/SViewDocBtn.vue'
import SGroupSelector from './components/Layout/SGroupSelector'
import { TASK_LIST_JOB_TYPE, WORKFLOW_ACTION_TYPE, APP_CODE_STATUS, ID_SIGN_COMPLETE_CB_URL, LOADING_TIMEOUT, BUSINESS_CODE } from '@/constant/constant'
import SDeleteDialog from './components/GeneralList/SDeleteDialog'
import signHelper from '@/helper/signHelper'
import idApi from '@/api/esign/identification'
import workflowApi from '@/api/workflow/workflow'
import SFlowDetailDialog from './components/GeneralList/SFlowDetailDialog.vue'

if (!store.state[workflowModule]) store.registerModule(workflowModule, workflow)

export default {
  components: {
    STaskListLayout,
    STransferTask,
    // SClassPdf,
    SClassPdfMuti,
    SViewDocBtn,
    SGroupSelector,
    SDeleteDialog,
    SFlowDetailDialog
  },
  mixins: [taskMethod],
  props: {
    businessCode: {
      type: String,
      required: true
    },
    groupId: {
      type: String,
      default: null
    }
  },
  data: () => {
    return {
      mdiClose,
      mdiRedo: mdiRedo,
      jobType: TASK_LIST_JOB_TYPE.GROUP_JOB,
      isShowSignBasket: false,
      requireMessage: true,
      loading: false,
      itemsPerPage: 10,
      page: 1,
      totalPage: 0,
      currGroupId: null,
      taskList: [],
      filterText: '',
      isShowCancelTaskDialog: false,
      currentTask: null,
      sGroupSelectorKey: 0, // HACK: use Key-changing to force re-renders of a component
      actionTypeCancel: WORKFLOW_ACTION_TYPE.CANCEL,
      cancelLoading: {},
      BUSINESS_CODE,
      files: [],
      dialog: false // pdf dialog
    }
  },
  computed: {
    // ...mapWorkflowMultiRowFields({
    //   taskList: 'groupWorkItems'
    // }),
    // ...mapState(staffModule, {
    //   staff: state => state.info
    // })
    ...mapState(workflowModule, {
      workItem: state => state.item
    })
  },
  watch: {
    businessCode: async function () {
      this.loading = true
      this.currGroupId = null
      this.sGroupSelectorKey += 1
    },
    currGroupId: async function (val) {
      // this.getGroupActiveItems(val)
      if (val) {
        this.page = 1
        this.getGroupItems()
      }
    }
  },
  async created () {
    this.loading = true
    if (this.groupId) {
      this.currGroupId = parseInt(this.groupId)
    }
    // if (!this.staff) {
    //   await this.$store.dispatch(staffModule + '/getStaff')
    // }
    this.$store.dispatch(workflowModule + '/getItemByBusinessCode', this.businessCode)
    // this.loading = false
  },
  methods: {
    handlePageChange (value) {
      this.page = value
      this.getGroupItems()
    },
    askWhetherCancelTask: function (task) {
      this.currentTask = task
      this.isShowCancelTaskDialog = true
    },
    confirmDelete (message) {
      this.$set(this.cancelLoading, [this.currentTask.id], true)
      this.currentTask.opinion = message
      this.cancelWorkItem(this.currentTask, this.genFormMeta(this.currentTask, null, this.currGroupId))
      this.currentTask = null
    },
    confirmCancel (message) {
      this.$set(this.cancelLoading, [this.currentTask.id], true)
      this.currentTask.opinion = message
      let formMetas = {
        documentId: this.currentTask.formCode,
        assignedToEuid: null,
        workItemId: this.currentTask.id + '',
        action: this.actionTypeCancel + '',
        signatureFieldName: this.currentTask.signatureFieldName,
        commentFieldName: this.currentTask.commentFieldName,
        comment: this.currentTask.opinion,
        appStatusCode: APP_CODE_STATUS[this.actionTypeCancel]
      }
      this.signTask(this.currentTask, formMetas)
      this.currentTask = null
      this.isShowCancelTaskDialog = false
      this.refreshTaskListCount()
    },
    signTask: async function (task, formMetas) {
      let form = {
        businessCode: this.businessCode,
        documentId: task.formCode,
        // euid: this.staff.euid,
        'formMetas': formMetas,
        language: null,
        redirectUri: ID_SIGN_COMPLETE_CB_URL
      }
      // this.loading = true
      let signObj = {}
      signObj[signHelper.GET_SIGN_LINK_URL] = idApi.updatePdfAndBuildIdLinkUrl
      signObj[signHelper.SIGN_AND_START_WORKFLOW_URL] = workflowApi.idSignAndCompleteUrl
      signObj[signHelper.REDIRECT_PATH] = 'tasklist/generalGroupList/' + this.businessCode + '/' + this.currGroupId
      signObj[signHelper.POST_FORM] = JSON.stringify(form)
      signObj[signHelper.SUCCESS_MSG_KEY] = ''
      signObj[signHelper.FAIL_MSG_KEY] = 'TaskList.eSign.FailMessage'

      signHelper.signAndStartWorkflow(signObj) // signAndComplete
      setTimeout(() => {
        this.$set(this.cancelLoading, [task.id], false)
      }, LOADING_TIMEOUT)
    }
    /* confirmUn
    // getGroupActiveItems: async function (val) {
    //   if (val) {
    //     this.loading = true
    //     await this.$store.dispatch(workflowModule + '/getGroupItems', { 'businessCode': this.businessCode, 'groupId': val })
    //     this.loading = false
    //   }
    // }
    */
  }
}
</script>
